<template>
    <div>

        <defNavBar title="Ares - Restore prices from back-up" :home=true />

        <v-main>
            <v-container fluid class="px-5">
                <hsptHeader :hspt="hspt" class="mb-2" />
                <v-row dense>
                    <v-col cols="4">
                        <restore_backup_from_json ref="restore" label="Select your backup here" icon="mdi-code-json"
                            :hspt="hspt" :show_summary=true @loadObject="loadObject" />
                    </v-col>
                </v-row>
                <div v-if="backup_type === 'hsnp'">
                    <v-row>
                        <v-col cols="12">
                            <v-data-table :headers="getHsnpTableHeaders()" :must-sort=true :items="obj.prices"
                                :disable-pagination=true flat :height="wInnerHeight - 384" dense fixed-header
                                item-key="hsnp_datum_sort" no-data-text="No data available" hide-default-footer
                                class="table-font">
                                <template v-slot:item.hsnp_datum_sort="{ item }">
                                    <td>{{ $moment(item.hsnp_datum_sort).format("DD-MM-YYYY") }}</td>
                                </template>
                                <template v-slot:item.hsnp_priority="{ item }">
                                    <td><span v-if="item.hsnp_priority!==0"><v-avatar :size="18" style="border: solid 1px red; margin-right: 5px;"><v-icon color="red" small>mdi-parking</v-icon></v-avatar></span></td>
                                </template>
                                <template v-slot:item.hsnp_min_inkoop="{ item }">
                                    <span v-if="item.hsnp_min_inkoop !== ''">
                                        <td align="right">€ {{ item.hsnp_min_inkoop }}</td>
                                    </span>
                                </template>
                                <template v-slot:item.hsnp_inkoop_display="{ item }">
                                    <td align="right">€ {{ item.hsnp_inkoop_display }}</td>
                                </template>
                                <template v-slot:item.hsnp_verkoop_display="{ item }">
                                    <td align="right">€ {{ item.hsnp_verkoop_display }}</td>
                                </template>
                                <template v-slot:item.hsnp_margin_display="{ item }">
                                    <td align="right">{{ item.hsnp_margin_display }} %</td>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </div>
            </v-container>
        </v-main>

        <v-row v-if="backup_type === 'hsnp'">
            <v-spacer /><v-btn color="success" class="fixed-position" v-on:click="restoreData"><v-icon
                    class="mr-2">mdi-upload</v-icon>Restore</v-btn>
        </v-row>

        <standard_dialog ref="std_dialog" />

    </div>
</template>

<script>

import restore_backup_from_json from '@/components/restore_backup_from_json.vue';
import standard_dialog from '@/components/ui/standard_dialog.vue';
import hsptHeader from '@/components/huis/hspt/ui/hspt_header_card.vue';
import defNavBar from '@/components/ui/navbars/navbar.vue';

export default {

    props: {
        hspt_encrid: String
    },
    components: {
        restore_backup_from_json,
        standard_dialog,
        defNavBar,
        hsptHeader,
    },
    created() {
        window.addEventListener("resize", this.resizeEventHandler);
        this.getContractData();
    },
    destroyed() {
        window.removeEventListener("resize", this.resizeEventHandler);
    },
    data() {
        return {
            hspt: {},
            backup_type: '',
            obj: null,
            wInnerHeight: window.innerHeight,
        }
    },
    methods: {
        resizeEventHandler() {
            this.wInnerHeight = window.innerHeight;
        },
        getContractData() {
            this.$axios
                .post("ares/json/ares/huis/hspt/hsnp/getSingleHspt.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getSingleHspt"
                    },
                    getSingleHspt: {
                        hspt_encrid: this.hspt_encrid,
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        this.showDialog('error', 'Error', res.data.error.message);
                    } else {
                        this.hspt = res.data.getSingleHspt;
                        this.hspt.title = res.data.getSingleHspt.price_structure.toUpperCase() === 'NIGHT' ? 'Ares - Night prices' : 'Ares - LOS prices';
                    }
                })
        },
        getHsnpTableHeaders() {
            return [
                { text: "", value: "hsnp_datum_day", sortable: false },
                { text: "Datum", value: "hsnp_datum_sort", sortable: false },
                { text: "", value: "hsnp_priority",sortable: false, width: "1%"},
                { text: "Min. purchase", align: "end", sortable: false, value: "hsnp_min_inkoop_display" },
                { text: "Purchase price", align: "end", sortable: false, value: "hsnp_inkoop_display" },
                { text: "Sales price", align: "end", sortable: false, value: "hsnp_verkoop_display" },
                { text: "Margin", align: "end", sortable: false, value: "hsnp_margin_display" },
                { text: "Arrival", value: "hsnp_van", sortable: false },
                { text: "Departure", value: "hsnp_tm", sortable: false },
                { text: "Min. nights", align: "center", value: "hsnp_min_aant_nacht_display", sortable: false },
                { text: "Week price", align: "end", value: "hsnp_weekprijs_display", sortable: false },
                { text: "Cleaning", align: "center", value: "hsnp_schoonmaak_display", sortable: false },
                { text: "Planning", align: "center", value: "hsnp_planning_display", sortable: false },
                { text: "Updated", value: "hsnp_dt_display", sortable: false },
            ];
        },
        loadObject(obj) {
            if (obj === null) {
                this.backup_type = '';
            }
            this.obj = obj;
            if (obj !== null) {
                this.backup_type = obj.backup;
            }
        },
        getUUID() {
            return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
        },
        generateStorageEvent(target) {
            localStorage.setItem(target, this.getUUID());
        },
        showDialog(type, caption, message) {
            this.$refs.std_dialog.open(type, caption, message);
        },
        restoreData() {
            this.obj.hspt_encrid = this.hspt_encrid;
            this.$axios
                .post("ares/json/ares/huis/hspt/hsnp/restoreMultipleHsnpv2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "processData"
                    },
                    processData: this.obj,
                })
                .then(res => {
                    if (res.data.error) {
                        this.showDialog('error', 'Error', res.data.error.message);
                    } else {
                        // refresh parent in other tab
                        this.generateStorageEvent('reload_hsnp');                        
                        this.showDialog('info', 'Price(s) restored', `Successfully restored ${res.data.processData.updates} prices`);
                        this.$refs.restore.callClear();
                    }
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.fixed-position {
    position: absolute;
    right: 15px;
    bottom: 15px;
}
</style>